//* Libraries imports
import { z } from "zod";

export enum MethodPaymentEnum {
  CREDIT_CARD = "CREDIT_CARD",
  TED = "TED",
  PIX = "PIX",
  BOLETO = "BOLETO",
}

export const MethodPaymentSchema = z.nativeEnum(MethodPaymentEnum);

export const MethodPaymentEnumLabel = {
  [MethodPaymentEnum.CREDIT_CARD]: "Cartão de Crédito",
  [MethodPaymentEnum.TED]: "Transferência Eletrônica",
  [MethodPaymentEnum.PIX]: "PIX",
  [MethodPaymentEnum.BOLETO]: "Boleto",
};

export type MethodPaymentDTO = z.infer<typeof MethodPaymentSchema>;
